import * as React from 'react';

function Youtube(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 4A2.503 2.503 0 001 6.5v11C1 18.878 2.121 20 3.5 20h17c1.379 0 2.5-1.122 2.5-2.5v-11C23 5.122 21.879 4 20.5 4h-17zm17 17h-17C1.57 21 0 19.43 0 17.5v-11C0 4.57 1.57 3 3.5 3h17C22.43 3 24 4.57 24 6.5v11c0 1.93-1.57 3.5-3.5 3.5z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.513 9.723l.027 4.542 3.949-2.294-3.976-2.248zm-.961 6.274l-.05-7.994 6.996 3.955-6.946 4.039z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Youtube;
